<template>
	<div>
		<h6><strong>Datos del Comprobante</strong></h6>
		<div class="row">
			<div class="col-xl-2">
				<div class="form-group">
					<label for="" class="form-label">Tipo:</label>
					<InputSelect
						v-model="comprobante.tipoDoc"
						:options="containers.comprobanteTiposDoc"
						label="nombre"
						:disabled="loading.numeroDoc || estaFacturado"
						:loading="loading.numeroDoc"
						:reduce="(opt) => opt.idDocVenta"
						name="Tipo"
						vid="comprobanteTipo"
						rules="required"
					></InputSelect>
				</div>
			</div>
			<div class="col-xl-2">
				<div class="row">
					<div class="col-6">
						<div class="form-group">
							<label for="" class="form-label">Serie:</label>
							<div class="form-control form-control-sm disabled">
								{{ serie }}
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form-group">
							<label for="" class="form-label">Número (Ref.):</label>
							<div class="form-control form-control-sm disabled">
								{{ numeroDoc }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-2">
				<div class="form-group">
					<label for="" class="form-label">Fecha de Emisión:</label>
					<InputDatepicker v-model="comprobante.fechaEmision" name="Fecha de Emisión" vid="fechaEmision" rules="required" :disabled="estaFacturado"></InputDatepicker>
				</div>
			</div>
			<div class="col-xl-2">
				<div class="form-group">
					<label for="" class="form-label">Transacción:</label>
					<InputSelect
						v-model="comprobante.transaccion"
						:reduce="(opt) => opt.idTransaccion"
						:options="containers.transacciones"
						label="nombre"
						name="Transacción"
						vid="transaccion"
						rules="required"
						:disabled="estaFacturado"
					></InputSelect>
				</div>
			</div>
			<div class="col-xl-1">
				<div class="form-group">
					<label for="" class="form-label">Moneda:</label>
					<InputSelect
						v-model="comprobante.moneda"
						:reduce="(opt) => opt.idMoneda"
						:options="containers.monedas"
						label="sigla"
						name="Moneda"
						vid="moneda"
						rules="required"
						:disabled="!esModoManual || estaFacturado"
					></InputSelect>
				</div>
			</div>
			<div class="col-xl-3">
				<div class="row">
					<div class="col-6">
						<div class="form-group">
							<label for="" class="form-label">Tipo de Pago:</label>
							<InputSelect
								v-model="comprobante.tipoPago"
								:reduce="(opt) => opt.idPagoTipo"
								:options="containers.tiposPago"
								label="nombre"
								name="Tipo de Pago"
								vid="tipoPago"
								rules="required"
								:disabled="estaFacturado"
							></InputSelect>
						</div>
					</div>
					<div class="col-6" v-if="esPagoAlCredito">
						<div class="form-group">
							<label for="" class="form-label">Días:</label>
							<InputText v-model="comprobante.pagoDias" rules="required|number|greater:0" :disabled="estaFacturado"></InputText>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-4">
				<div class="form-group">
					<label for="" class="form-label">Observaciones:</label>
					<InputTextArea v-model="comprobante.observaciones" :maxHeight="100" name="Observaciones" vid="observaciones" rules="max:1000" :disabled="estaFacturado"></InputTextArea>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputTextArea from "../../shared/components/InputTextArea.vue";
import InputText from "../../shared/components/InputText.vue";
import { mapGetters, mapState } from "vuex";

export default {
	components: { InputText, InputTextArea, InputSelect, InputDatepicker },
	computed: {
		...mapState("comprobante2", {
			comprobante: (state) => state.comprobante,
		}),
		...mapGetters("comprobante2", ["containers", "loading", "estaFacturado", "serie", "numeroDoc", "esModoManual", "esPagoAlCredito"]),
	},
};
</script>

<style></style>
